import { render, staticRenderFns } from "./svg-other.vue?vue&type=template&id=8e9cd946&scoped=true"
import script from "./svg-other.vue?vue&type=script&setup=true&lang=ts"
export * from "./svg-other.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./svg-other.vue?vue&type=style&index=0&id=8e9cd946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9cd946",
  null
  
)

export default component.exports